import { useEffect, useState } from 'react'

import { useContentConsumption } from '@space-shell/common/components/baseStructure/hooks/useContentConsumption'
import { AuthStatus, useAuthContext } from '@space-shell/common/contexts/auth'
import usePurchases from '@space-shell/common/hooks/usePurchases'
import type { PurchasedData } from '@space-shell/common/services/product/types'
import { useMembershipStore } from '@space-shell/core/store'
import { useParams } from 'react-router-dom'

import type { CollectionsComponentProps } from './types'

import { DelayedPurchaseChargeModal, PurchaseChargeAlert } from '../'

export const CollectionsWrapper = ({ container, appOrigin }: CollectionsComponentProps) => {
  const { membershipData } = useMembershipStore()
  const { authStatus } = useAuthContext()
  const [activePurchase, setActivePurchase] = useState<PurchasedData>()
  const [clientHasChargeDelayed, setClientHasChargeDelayed] = useState(false)
  const { productId: purchaseId } = useParams<{ productId: string }>()
  const isClassRoom = useContentConsumption()

  const { data: purchases } = usePurchases({
    params: {
      pageSize: membershipData?.settings?.showSections ? 1 : 0
    },
    options: {
      enabled: authStatus === AuthStatus.AUTHENTICATED
    }
  })

  useEffect(() => {
    if (!purchases?.content?.length || !purchaseId) return

    const purchase = purchases.content.find((purchase) => String(purchase.id) === purchaseId)
    if (!purchase) return
    setActivePurchase(purchase)
    setClientHasChargeDelayed(
      purchase.subscription?.subscriptionStatus === 'DELAYED' &&
        purchase.subscription?.isHotmartInstallment
    )
  }, [purchases, purchaseId, isClassRoom])

  if (clientHasChargeDelayed && activePurchase && isClassRoom) {
    return <DelayedPurchaseChargeModal container={container} activePurchase={activePurchase} />
  }

  return (
    <PurchaseChargeAlert
      container={container.current}
      appOrigin={appOrigin}
      productId={purchaseId}
      purchases={purchases?.content || []}
    />
  )
}

export default CollectionsWrapper
